import { Text } from "@mantine/core";

import useImageSrc from "../../utils/useImageSrc";
import { useTheme } from "../../hooks";

interface Props {
  useBase64?: boolean;
}

const CISRHeader = ({ useBase64 }: Props) => {
  const theme = useTheme();
  const imageSrc = useImageSrc("/assets/Cayman-Registry-Logo.png", useBase64);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <img src={imageSrc ?? ""} height={80} style={{ borderRadius: 20 }} />
      <div>
        <Text style={{ textAlign: "end", fontSize: "9px" }}>
          <a
            style={{
              fontWeight: 200,
              fontSize: "9px",
              textDecoration: "none",
            }}>
            Cayman Islands Shipping Registry
            <br />
            HEAD OFFICE <br />
          </a>
          133 Elgin Avenue P.O. Box 2256 <br />
          Grand Cayman KY1-1107 Cayman Islands <br />
          Tel: +1 345 949 8831 Fax: +1 345 949 8849 <br />
          Email: survey.ky@cishipping.com <br />
          Website: <a href="http://www.cishipping.com">www.cishipping.com</a>
        </Text>
      </div>
    </div>
  );
};
export default CISRHeader;
